﻿<template>
    <div class="container">
        <div v-if="categories && categories.length">

            <b-accordion class="accordion-filter">
                <div class="accordion-title pb-2">{{ $t('categories') }}</div>
                <b-accordion-item v-for="(category, index) in categories"
                                  :key="`Category-${index}`"
                                  :title="category.name"
                                  :visible="category.id === categoryId || category.sub_categories.some(c => c.id === categoryId)"
                                  :class="[{'active': category.id === categoryId}, 'border-top border-2']"
                                  @click="gotToCategory(category)">
                    <b-list-group>
                        <b-list-group-item v-for="(subCategory, subIndex) in category.sub_categories" :key="`sub-category-${subIndex}`"
                                           class="ps-5 cursor-pointer"
                                           @click.stop.prevent="gotToCategory(category, subCategory)"
                                           :active="subCategory.id === categoryId">
                            {{ subCategory.name }} ({{ subCategory.custom_properties.ProductCount }})
                        </b-list-group-item>
                    </b-list-group>
                </b-accordion-item>
            </b-accordion>
        </div>
    </div>
</template>

<script>
    import { CustomerConstant } from "@/constants/customer-constant";

    export default {
        props: {
            categories: {
                type: Array
            },

            categoryId: {
                type: Number
            },

            showAllProducts: {
                type: Boolean
            }
        },

        methods: {
            gotToCategory(category, subCategory) {
                let link = `/${category.se_name}`;

                if (subCategory)
                    link += `/${subCategory.se_name}`;

                this.showAllProducts
                    ? this.$router.replace({ path: link, query: { view: CustomerConstant.allProductsViewName } })
                    : this.$router.replace({ path: link });
            }
        }
    }
</script>